import { render } from "./AiPrinciplesPage.vue?vue&type=template&id=47cde7bf&ts=true"
import script from "./AiPrinciplesPage.vue?vue&type=script&lang=ts"
export * from "./AiPrinciplesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__